<template>
    <div class="mpS3">
        <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide>
                <div class="page">
                    <div class="page-top">
                        <span>LIVE SHOPPING</span>
                    </div>
                    <div class="page-bottom">
                            <div class="mobile-img">
                                <img src="@/assets/mpS3-1.png">
                            </div>
                            <div class="page-ment">
                                <div class="page-ment-big">
                                    직접 참여하는 신개념 라이브 쇼핑
                                </div>
                                <div class="page-ment-small">
                                    아직도 이미지만 보고 쇼핑하시나요?
                                    이젠 실시간 라이브로 쇼핑을 해보세요~
                                    궁금한 점은 바로바로 해결하고
                                    요즘 핫한 트랜드를 실시간으로 만나보는
                                    REAL TIME 쇼핑세계를 맛보세요.
                                </div>
                            </div>
                        
                    </div>
                </div>
            </swiper-slide>
            <!-- page1 끝 -->
             <swiper-slide>
                <div class="page">
                    <div class="page-top">
                        <span>ALL IN ONE</span>
                    </div>
                    <div class="page-bottom">
                            <div class="mobile-img">
                                <img src="@/assets/mpS3-2.png">
                            </div>
                            <div class="page-ment">
                                <div class="page-ment-big">
                                    패션,뷰티가 한자리에 모였다
                                </div>
                                <div class="page-ment-small">
                                 내가 원하는 상품을 아직도 여기저기에서
                                    어렵게 찾고 계신가요?
                                    전국에 핫한 잇템들을 여기에 모아 쉽고
                                    간편한 검색을 통해 원하는 상품을 쉽게쉽게
                                    GET 해 보세요
                                </div>
                            </div>
                        
                    </div>
                </div>
            </swiper-slide>
            <!--  page2 -->
             <swiper-slide>
                <div class="page">
                    <div class="page-top">
                        <span>SMART RECOMMENDATION</span>
                    </div>
                    <div class="page-bottom">
                            <div class="mobile-img">
                                <img src="@/assets/mpS3-3.png">
                            </div>
                            <div class="page-ment">
                                <div class="page-ment-big">
                                    당신만을 위한 스마트한 추천
                                </div>
                                <div class="page-ment-small">
                                 많고 많은 상품중에서 당신의 취향을
                                    저격하는 상품은 어디에 있을가요?
                                    ON STYLE LIVE는 당신의 나이와 취향을
                                    분석해 당신이 발견하지 못한 취향저격 상품들만
                                    쏙쏙 골라서 보여주고 있습니다.
                                </div>
                            </div>
                        
                    </div>
                </div>
            </swiper-slide>
            <!-- page3 -->
             <swiper-slide>
                <div class="page">
                    <div class="page-top">
                        <span>TREND PICK</span>
                    </div>
                    <div class="page-bottom">
                            <div class="mobile-img">
                                <img src="@/assets/mpS3-4.png">
                            </div>
                            <div class="page-ment">
                                <div class="page-ment-big">
                                    매주 업데이트 되는 TREND PICK
                                </div>
                                <div class="page-ment-small">
                                    요즘 유행하는 엣팀은 무엇일가요?
                                    하루 24시간이 모자란 당신을 위해
                                    ON STYLE LIVE는 꼼꼼한 트랜드 분석을
                                    통해 얻은 상품들만 엄선해서 추천해주는
                                    TREND PICK을 매주 새롭게 만나보세요
                                </div>
                            </div>
                        
                    </div>
                </div>
            </swiper-slide>
            <!-- page4 -->
             <swiper-slide>
                <div class="page">
                    <div class="page-top">
                        <span>SPECIAL FOR YOU</span>
                    </div>
                    <div class="page-bottom">
                            <div class="mobile-img">
                                <img src="@/assets/mpS3-5.png">
                            </div>
                            <div class="page-ment">
                                <div class="page-ment-big">
                                    나만의 ON STYLE LIVE
                                </div>
                                <div class="page-ment-small">
                                    마음에 드는 채널은 바로바로 구독하고
                                    새로운 소식,좋은 정보들을 많이 얻어가세요.
                                    내가 즐겨찾는 채널들을 한자리에 모아
                                    오직 나만의 특별한 ON STYLE LIVE를 만들어보세요
                                </div>
                            </div>
                        
                    </div>
                </div>
            </swiper-slide>
            <!-- page5 -->

        </swiper>
    </div>
</template>
<script>
    export default {
        name: "mpSlide3",
        data() {
            return {
                swiperOptions: {
                    direction: 'horizontal',
                    autoplay: {
                        delay: 4000,
                    },
                    loop: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .mpS3 {
        width: 100%;
        height: 750px;
        padding-top: 25px;
        padding-bottom: 25px;
        background-color: #f5f0e7;
        position: relative;

        .page {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            position: relative;
            .page-top {
                width: 100%;
                height: 80px;
                 position: absolute;
                top: 0;
                left: 0;
                z-index: 888;
                background-color: #ece5da;
                text-align: center;
                  span {
                    font-size: 24px;
                    font-weight: 900;
                    color: #f1ebe5;
                    text-shadow: 0 13.36px 8.896px #c4b59d, 0 -2px 1px #ffffff;
                    letter-spacing: 2px;
                    line-height: 80px;
                }
            }
             .page-bottom {
                width: 100%;
                height: 100%;
                padding-top: 120px;
                box-sizing: border-box;
                background-color: #f5f0e7;
                text-align: center;
                position: relative;

                    .mobile-img {
                        width: 100%;
                        text-align: center;
                        margin-bottom: 40px;
                        position: relative;
                        img {
                            width: 60%;
                        }
                    }

                    .page-ment {
                        display: flex;
                        flex-direction: column;

                        .page-ment-big {
                            font-size: 24px;
                            font-weight: 900;
                            color: #aca599;
                            margin-bottom: 10px;
                        }

                        .page-ment-small {
                            padding: 0px 30px 0px 30px;
                            font-size: 14px;
                            color: #948e82;
                        }
                    }
                }

            
        }


    }
</style>